export const NON_RUNNING_RUN_STATES = new Set(['idle', 'paused', 'blocked', 'needs_desktop', 'retry_available', 'complete', 'completed', 'success', 'succeeded', 'done', 'error', 'failed', 'canceled', 'cancelled']);

const PENDING_CANCEL_RUN_STATES = new Set(['canceling', 'cancelling']);

export const normalizeRunStateValue = (value) => {
  return String(value || '')
    .trim()
    .toLowerCase();
};

export const isRunStateInProgress = (value) => {
  const normalized = normalizeRunStateValue(value);

  if (!normalized) {
    return false;
  }

  return !NON_RUNNING_RUN_STATES.has(normalized);
};

// Sidebar/composer spinner predicate: the user already clicked Cancel, so even
// though `canceling` is not terminal yet, we want to stop showing a busy
// indicator. Consumers that need the strict "terminal" semantic (composer
// flush, send-context gating, streaming merge guard) keep using
// NON_RUNNING_RUN_STATES.
export const isRunStateActivelyExecuting = (value) => {
  const normalized = normalizeRunStateValue(value);

  if (!normalized) {
    return false;
  }

  return !NON_RUNNING_RUN_STATES.has(normalized) && !PENDING_CANCEL_RUN_STATES.has(normalized);
};
